<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'app',
    metaInfo: {
      title: 'Locations',
      titleTemplate: '%s | Katie Paterson: First There is a Mountain'
    },
    components: {
    }
  }
</script>

<style lang="css">
@import 'css/app.css';
</style>
